module.exports = __webpack_public_path__ + "media/images/athletes/3106-2685b306864c75ca38769f2bd2869542.png";